module.exports = __webpack_public_path__ + "static/media/zanny.6907f1bd.jpg";